import info from "../../../../../assets/icons/info_gold.svg";
import { useRive } from "@rive-app/react-canvas";
import coupon from "../../../../../assets/animations/coupon.riv";
import { useState } from "react";
import { FaCopy } from "react-icons/fa";
import { Address } from "viem";
import { snackBar } from "../../../../../utils/Utils";
import { SentryUtils } from "../../../../../utils/SentryUtils";

export interface CouponsProps {
  ticketLimitPerPurchase: number;
  points: number;
  address?: Address;
}

export default function Coupons(props: CouponsProps) {
  const { RiveComponent } = useRive({
    src: coupon,
    stateMachines: "state_machine",
    autoplay: true,
  });

  const [link] = useState(`${window.location.origin}/?ref=${props.address}`);

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(link);
      snackBar("Copied to clipboard!", "📋", 2000);
    } catch (err) {
      SentryUtils.customIssue(
        "Failed to copy referral link to clipboard.",
        "error",
      );
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div
      className="flex flex-col items-center lg:items-start"
      data-aos="fade-left"
    >
      <div className="flex flex-row items-center ~mb-0.25/0.5 justify-center">
        <span className="font-barlowc font-bold ~text-base/lg bg-gradient-to-b from-mango to-crail bg-clip-text text-transparent">
          COUPONS
        </span>
        <img
          src={info}
          className="select-none ~pl-1/1.5 ~h-3.5/4.5"
          alt="info"
          data-tooltip-html={
            "Use coupons to purchase tickets at discounted prices! Earn points by sharing your referral link with friends. Each time a friend makes a purchase, you receive points. Collect more points to unlock more coupons!"
          }
          data-tooltip-id="default-tooltip"
        />
      </div>
      <div className="flex flex-row ~mb-1.5/2 hover:scale-105 duration-250 items-center justify-center">
        <div className="w-[40px] h-[40px] flex-none">
          <RiveComponent />
        </div>
        <p className="font-archb font-bold text-silver ~text-lg/xl ~leading-3/5">
          {Math.floor(props.points / props.ticketLimitPerPurchase)}
        </p>
        <div className="flex flex-col ~ml-3/4">
          <div className="font-barlowc text-silver text-base ~mb-0.5/1">
            {props.ticketLimitPerPurchase -
              (props.points % props.ticketLimitPerPurchase)}{" "}
            points until your next coupon
          </div>
          <div className="w-full bg-gray-200 rounded-md h-2 overflow-hidden bg-bastille">
            <div
              className="bg-waterloo h-full transition-all duration-300 ease-in-out"
              style={{
                width: `${((props.points % props.ticketLimitPerPurchase) * 100) / props.ticketLimitPerPurchase}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
      <div className="flex font-barlowc text-silver text-base ~mb-0.5/1 justify-center">
        Your referral link
      </div>
      {props.address != undefined && (
        <div
          onClick={handleCopyClick}
          className="flex flex-row cursor-pointer text-sm text-gray-700 bg-silver-light rounded-md ~p-1/1.5 hover:scale-105 duration-250"
        >
          <span className="~w-48/56 pr-1.5 truncate">{link}</span>
          <FaCopy className="text-bastille cursor-pointer ~text-xxl/xl" />
        </div>
      )}
    </div>
  );
}
